var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(-1035 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    transform: "translate(1035 18)",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(1045 27.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_88",
    "data-name": "Trazado 88",
    d: "M23.556,17.7l-2.027-3.743v-3.9a7.057,7.057,0,0,0-14.114,0v3.9L5.387,17.7a1.114,1.114,0,0,0,.98,1.645H10.4q-.017.185-.017.371a4.086,4.086,0,0,0,8.171,0c0-.125-.006-.249-.017-.371h4.036a1.114,1.114,0,0,0,.98-1.645Zm-6.485,2.016a2.6,2.6,0,1,1-5.173-.371h5.146a2.607,2.607,0,0,1,.027.371ZM6.991,17.857,8.9,14.331V10.057a5.571,5.571,0,0,1,11.143,0v4.274l1.91,3.526Z",
    transform: "translate(-5.253 -3)",
    fill: "#122866"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationes);
export default __webpack_public_path__ + "static/media/notificationes.421ce914bfce1401bbc4d81688ac004d.svg";
export { ForwardRef as ReactComponent };